import LoginLeftSection from './components/loginLeftSection';
import LoginRightSection from './components/loginRightSection';
import useGetTokenAndRedirectToDashboard from './hooks/useGetTokenAndRedirectToDashboard';

const Login = () => {
  useGetTokenAndRedirectToDashboard();

  return (
    <section className='grid min-h-screen grid-cols-1 md:grid-cols-[36%_64%]'>
      <div>
        <LoginLeftSection />
      </div>
      <div>
        <LoginRightSection />
      </div>
    </section>
  );
};

export default Login;
